<template>
  <div class="px-3 px-md-5 d-flex flex-column flex-md-row align-items-center justify-content-between gap-2 rounded-2 bg-white py-4 w-100">
      <div>
        <h1> Mes Dépenses </h1>
      </div>
      <div class="d-flex flex-column flex-md-row align-items-center justify-content-end gap-2 w-75">
        <Input
            container-class="me-2"
            size="sm"
            inputClass="form-control form-control-sm"
            name="input-search"
            :isInputGroup="true"
            :placeholder="$t('label.search')"
            v-model="query.search"
        >
          <template #rightAddon>
          <span class="position-absolute border-0 bg-transparent end-0 top-50 translate-middle">
            <i class="fa fa-search"></i>
          </span>
          </template>
        </Input>
        <DateRangePicker :id="id" @update:date="handleRangeDate" />
        <ButtonDropdownFilter
            :btn-title="$t('expense.label.allStatus')"
            :search="false"
            :options="Object.values(status)"
            value-field="value"
            :name-field="locale"
            v-model="query.status"
        />
        <ButtonDropdownFilter
            :btn-title="$t('expense.label.allTypes')"
            :search="false"
            :options="Object.values(types)"
            value-field="title"
            :name-field="locale"
            v-model="query.type"
        />
      </div>
  </div>
</template>
<script setup>
import DateRangePicker from "@/components/DateRangePicker.vue";
import ButtonDropdownFilter from "@/components/ButtonDropdownFilter.vue";
import { useLocales } from "@/composables/locales";
import Input from "@/components/Input.vue";

const {locale} = useLocales()

const props = defineProps({
  handleRangeDate: {type: Function, default: () => {}},
  types: { type: Object, default:  {}},
  status: { type: Object, default:  {}},
  id: {type: String, default: 'kt_td_picker_button'},
  query: {type: Object, default: {startDate: '', endDate: '', search: '', status: '', type: ''}}
})


</script>
<style scoped>
  @import "@eonasdan/tempus-dominus/dist/css/tempus-dominus.min.css";
</style>
